import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd5c34b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome-messages" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "환영합니다"),
  /*#__PURE__*/_createElementVNode("p", { class: "detail" }, [
    /*#__PURE__*/_createTextVNode(" 회원유형에 따라 회원가입 절차가 다릅니다. 본인이 해당하는"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 회원유형을 선택해 주세요. ")
  ])
], -1 /* HOISTED */))
const _hoisted_3 = { class: "signup-types" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "회원유형 선택" }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.signupInfos, (signUpInfo, index) => {
            return (_openBlock(), _createBlock($setup["TypeOfSignUpRow"], {
              key: index,
              useRankCode: signUpInfo.useRankCode,
              useRankName: signUpInfo.useRankName,
              onOnClickSignUp: $setup.goToTermsOfUse
            }, null, 8 /* PROPS */, ["useRankCode", "useRankName"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("p", {
            class: "sign-in",
            onClick: $setup.goToLogin
          }, "이미 회원이신가요? 로그인")
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}